import { Component, OnInit } from '@angular/core'

declare function ServicesEffect(): any
declare var $: any

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.scss'],
})
export class ServicesPageComponent implements OnInit {
  constructor() {}

  //seleton-loader
  loaded = true

  ngOnInit(): void {
    //seleton-loader
    // setInterval(() => {
    //   this.loaded = true;
    // });

    window.scroll(0, 0)

    ServicesEffect()
  }
}
